import { useCategoryMenuStore } from "~/stores/extensionApi/categoryMenu";
import { useConfigStore } from "~/stores/extensionApi/config";
import { useLayoutsStore } from "~/stores/extensionApi/layouts";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { useCustomAttributeMetadata } from "~/stores/customAttributeMetadata";

export default async ({ req }) => {
  try {
    const configStore = useConfigStore();
    const categoryMenuStore = useCategoryMenuStore();
    const layoutsStore = useLayoutsStore();
    const categories = useCategoryStore();
    const customAttributeMetadataStore = useCustomAttributeMetadata();

    if (process.server) {
      if (req.configData) {
        configStore.$patch({ configs: req.configData });
      }
      if (req.configMobileData) {
        configStore.$patch({ configsMobile: req.configMobileData });
      }
      if (req.megamenuData) {
        categoryMenuStore.$patch({ categoryMenuMega: req.megamenuData });
      }
      if (req.layoutsData) {
        layoutsStore.$patch({ layouts: req.layoutsData });
      }
      if (req.categoriesData) {
        categories.$patch({ rawCategories: req.categoriesData });
      }
      if (req.customAttributeMetadata) {
        customAttributeMetadataStore.$patch({ customAttributeMetadata: req.customAttributeMetadata });
      }
    }
  } catch (error) {
    console.error("Error initializing data store:", error);
  }
};
